import { render, staticRenderFns } from "./ContainerKCPInformationDocuments.vue?vue&type=template&id=621606b6"
import script from "./ContainerKCPInformationDocuments.vue?vue&type=script&lang=js"
export * from "./ContainerKCPInformationDocuments.vue?vue&type=script&lang=js"
import style0 from "./ContainerKCPInformationDocuments.vue?vue&type=style&index=0&id=621606b6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports